"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dateFns = require("date-fns");
var _invoke = _interopRequireDefault(require("lodash/invoke"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _graphql = require("@apollo/client/react/hoc/graphql");
var _reactIntl = require("react-intl");
var _mutationOptions = require("../../api/campaign/mutation-options");
var _mutations = require("../../api/campaign/mutations");
var _FormattedComponents = require("../FormattedComponents");
var _FormButton = require("../FormButton");
var _DurationPicker = require("../DurationPicker");
var _InfoModal = _interopRequireDefault(require("../InfoModal"));
var _SliderRating = _interopRequireDefault(require("../SliderRating"));
var _StarRating = _interopRequireDefault(require("../StarRating"));
var _enums = require("../../enums");
var _inputUtils = require("../../utils/input-utils");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("./messages"));
var _dec, _dec2, _class, _CampaignQuestionComponent;
var _excluded = ["device"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var BINARY_ANSWER_TRUE = 1;
var BINARY_ANSWER_FALSE = 0;
var FormButtonComponent = function FormButtonComponent(_ref) {
  var device = _ref.device,
    props = _objectWithoutProperties(_ref, _excluded);
  return device === 'desktop' ? /*#__PURE__*/_react["default"].createElement(_FormButton.FormButtonDesktop, props) : /*#__PURE__*/_react["default"].createElement(_FormButton.FormButtonMobile, props);
};
var CampaignQuestionComponent = (_dec = (0, _graphql.graphql)(_mutations.AnswerCampaignQuestion, _mutationOptions.answerCampaignQuestionOptions), _dec2 = (0, _mobxReact.inject)('store'), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (0, _mobxReact.observer)(_class = (_CampaignQuestionComponent = /*#__PURE__*/function (_Component) {
  function CampaignQuestionComponent() {
    var _this;
    _classCallCheck(this, CampaignQuestionComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CampaignQuestionComponent, [].concat(args));
    _defineProperty(_this, "userInputId", (0, _uniqueId["default"])('CampaignQuestion-user-'));
    _defineProperty(_this, "submitAnswer", function () {
      var form = _this.props.form;
      if (!form || !form.$('answer').isValid) {
        return;
      }
      (0, _invoke["default"])(_this.props, 'onAnswer');
    });
    _defineProperty(_this, "submitFollowUpAnswer", function () {
      (0, _invoke["default"])(_this.props, 'onFollowUpAnswer');
    });
    _defineProperty(_this, "submit", function () {
      var _this$props = _this.props,
        answerCampaignQuestionMutation = _this$props.answerCampaignQuestionMutation,
        instructionId = _this$props.instructionId,
        nextButton = _this$props.nextButton;
      (0, _invoke["default"])(_this.props, 'onSubmit', {
        instructionId: instructionId,
        mutation: answerCampaignQuestionMutation,
        nextButton: nextButton
      });
    });
    _defineProperty(_this, "syncAnswer", function (field, answer) {
      var form = _this.props.form;
      if (form) {
        form.$(field).sync(String(answer));
        form.validate();
      }
    });
    _defineProperty(_this, "renderQuestion", function () {
      var _this$props2 = _this.props,
        className = _this$props2.className,
        device = _this$props2.device,
        form = _this$props2.form,
        question = _this$props2.question,
        SliderComponent = _this$props2.SliderComponent;
      return /*#__PURE__*/_react["default"].createElement(_styles.CampaignQuestion, {
        className: className,
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_styles.ScrollableArea, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_styles.Section, {
        stretch: true
      }, /*#__PURE__*/_react["default"].createElement(_styles.Header, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_sign_off)), /*#__PURE__*/_react["default"].createElement(_styles.Heading, {
        "data-cy": "sign-off-question",
        device: device
      }, question.question), question.kind === _enums.CAMPAIGN_QUESTION_TYPE_ENUMS.YES_NO && _this.renderYesNoOptions(), question.kind === _enums.CAMPAIGN_QUESTION_TYPE_ENUMS.PASS_FAIL && _this.renderPassFailOptions(), question.kind === _enums.CAMPAIGN_QUESTION_TYPE_ENUMS.TEXT && _this.renderTextOptions(), question.kind === _enums.CAMPAIGN_QUESTION_TYPE_ENUMS.STAR && /*#__PURE__*/_react["default"].createElement(_StarRating["default"], {
        numOfRating: question.numOfRating,
        onSelect: function onSelect(value) {
          _this.syncAnswer('answer', value);
        }
      }), question.kind === _enums.CAMPAIGN_QUESTION_TYPE_ENUMS.NUMBER && /*#__PURE__*/_react["default"].createElement(_SliderRating["default"], {
        device: device,
        max: question.numOfRating,
        onChange: function onChange(value) {
          _this.syncAnswer('answer', value);
        },
        SliderComponent: SliderComponent,
        value: form && Number(form.$('answer').value)
      })), /*#__PURE__*/_react["default"].createElement(_styles.Section, null, _this.renderFootnote())), /*#__PURE__*/_react["default"].createElement(_styles.FooterSection, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(FormButtonComponent, {
        device: device,
        disabled: !form || !form.$('answer').isValid,
        onClick: _this.submitAnswer,
        isInverse: true
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_action_next))));
    });
    _defineProperty(_this, "renderFollowUpQuestion", function () {
      var _this$props3 = _this.props,
        className = _this$props3.className,
        device = _this$props3.device,
        followUpQuestion = _this$props3.followUpQuestion,
        form = _this$props3.form,
        formatMessage = _this$props3.intl.formatMessage;
      return /*#__PURE__*/_react["default"].createElement(_styles.CampaignQuestion, {
        className: className,
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_styles.ScrollableArea, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_styles.Section, {
        stretch: true
      }, /*#__PURE__*/_react["default"].createElement(_styles.Header, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_sign_off)), /*#__PURE__*/_react["default"].createElement(_styles.Heading, {
        "data-cy": "sign-off-follow-up-question",
        device: device
      }, followUpQuestion.question), followUpQuestion.kind === _enums.CAMPAIGN_FOLLOW_UP_TYPE_ENUMS.TEXT && /*#__PURE__*/_react["default"].createElement(_styles.MultilineTextbox, _extends({
        placeholder: formatMessage(_messages["default"].campaign_type_answer)
      }, form && (0, _inputUtils.bindField)(form, 'followUpAnswer'))), followUpQuestion.kind === _enums.CAMPAIGN_FOLLOW_UP_TYPE_ENUMS.TIME && /*#__PURE__*/_react["default"].createElement(_DurationPicker.DurationPicker, {
        device: device,
        onChange: function onChange(value) {
          _this.syncAnswer('followUpAnswer', value);
        }
      })), /*#__PURE__*/_react["default"].createElement(_styles.Section, null, _this.renderFootnote())), /*#__PURE__*/_react["default"].createElement(_styles.FooterSection, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(FormButtonComponent, {
        device: device,
        onClick: _this.submitFollowUpAnswer,
        isInverse: true
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_action_next))));
    });
    _defineProperty(_this, "renderSummary", function () {
      var _this$props4 = _this.props,
        className = _this$props4.className,
        device = _this$props4.device,
        disableModal = _this$props4.disableModal,
        form = _this$props4.form,
        formatMessage = _this$props4.intl.formatMessage,
        isSubmissionFailureModalOpen = _this$props4.isSubmissionFailureModalOpen,
        onSubmissionFailureModalClose = _this$props4.onSubmissionFailureModalClose,
        step = _this$props4.step;

      /*
       * When the user has successfully answered all the questions and we have
       * moved him to the slide with the "Thank you" text, this thing will still
       * remain on the left. Don't forget to disable all the controls here so that
       * it's no longer interactive.
       */

      var isThankYouStep = step === 'thank-you';
      return /*#__PURE__*/_react["default"].createElement(_styles.CampaignQuestion, {
        className: className,
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_styles.ScrollableArea, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_styles.Section, {
        stretch: true
      }, /*#__PURE__*/_react["default"].createElement(_styles.Header, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_sign_off)), /*#__PURE__*/_react["default"].createElement(_styles.Heading, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_submit_answers)), /*#__PURE__*/_react["default"].createElement(_styles.Summary, null, /*#__PURE__*/_react["default"].createElement(_styles.SummaryItem, null, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: _this.userInputId
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_your_name))), /*#__PURE__*/_react["default"].createElement(_styles.SummaryDetails, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_styles.Textbox, _extends({
        disabled: isThankYouStep
      }, form && (0, _inputUtils.bindField)(form, 'user'), {
        id: _this.userInputId
      })), /*#__PURE__*/_react["default"].createElement(_styles.SummaryFootnote, null, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_by_submitting))))), /*#__PURE__*/_react["default"].createElement(_styles.Section, null, _this.renderFootnote())), /*#__PURE__*/_react["default"].createElement(_styles.FooterSection, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(FormButtonComponent, {
        device: device,
        disabled: isThankYouStep || !form || !form.isValid,
        onClick: _this.submit
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_action_submit))), !disableModal && /*#__PURE__*/_react["default"].createElement(_InfoModal["default"], {
        isDesktop: device === 'desktop',
        isOpen: isSubmissionFailureModalOpen,
        onClose: onSubmissionFailureModalClose,
        onRightButtonClick: onSubmissionFailureModalClose,
        rightButtonText: formatMessage(_messages["default"].ok),
        subtitle: formatMessage(_messages["default"].sign_off_submission_failure_subtitle),
        title: formatMessage(_messages["default"].sign_off_submission_failure_title)
      }));
    });
    _defineProperty(_this, "renderFootnote", function () {
      var device = _this.props.device;
      var timeAgoLabel = _this.renderTimeAgoLabel();
      return timeAgoLabel ? /*#__PURE__*/_react["default"].createElement(_styles.Footnote, {
        device: device
      }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _extends({}, _messages["default"].campaign_last_sign_off, {
        values: {
          timeAgoLabel: timeAgoLabel
        }
      }))) : null;
    });
    _defineProperty(_this, "renderYesNoOptions", function () {
      return _this.renderOptions([{
        answer: BINARY_ANSWER_TRUE,
        label: /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_action_yes)
      }, {
        answer: BINARY_ANSWER_FALSE,
        label: /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_action_no)
      }]);
    });
    _defineProperty(_this, "renderPassFailOptions", function () {
      return _this.renderOptions([{
        answer: BINARY_ANSWER_TRUE,
        label: /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_action_pass)
      }, {
        answer: BINARY_ANSWER_FALSE,
        label: /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].campaign_action_fail)
      }]);
    });
    _defineProperty(_this, "renderTextOptions", function () {
      var question = _this.props.question;
      return _this.renderOptions(question.textTypeOptions.map(function (label, index) {
        return {
          answer: index + 1,
          label: label
        };
      }));
    });
    _defineProperty(_this, "renderOptions", function (answers) {
      var _this$props5 = _this.props,
        device = _this$props5.device,
        form = _this$props5.form;
      return /*#__PURE__*/_react["default"].createElement(_styles.AnswerButtons, {
        device: device
      }, answers.map(function (_ref2) {
        var label = _ref2.label,
          answer = _ref2.answer;
        var normalizedValue = String(answer);
        return /*#__PURE__*/_react["default"].createElement(_styles.AnswerButton, {
          key: normalizedValue,
          device: device,
          isSelected: form && normalizedValue === form.$('answer').value,
          onClick: function onClick() {
            return _this.syncAnswer('answer', normalizedValue);
          }
        }, label);
      }));
    });
    _defineProperty(_this, "renderTimeAgoLabel", function () {
      var dateNow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      var _this$props6 = _this.props,
        formatMessage = _this$props6.intl.formatMessage,
        lastDateOfAnswerForUser = _this$props6.lastDateOfAnswerForUser;
      if (lastDateOfAnswerForUser == null) {
        return null;
      }
      var minutesInHour = 60;
      var minutesInDay = 24 * minutesInHour;
      var minutesInMonth = 30 * minutesInDay;
      var minutesInYear = 12 * minutesInMonth;
      var diffInMinutes = (0, _dateFns.differenceInMinutes)(dateNow, new Date(lastDateOfAnswerForUser));
      var timestamp = (0, _dateFns.format)(lastDateOfAnswerForUser, 'M/D/YYYY h:mm A');
      if (diffInMinutes < minutesInHour) {
        return formatMessage(_messages["default"].campaign_minutes_ago, {
          minutes: diffInMinutes,
          timestamp: timestamp
        });
      }
      if (diffInMinutes < minutesInDay) {
        return formatMessage(_messages["default"].campaign_hours_ago, {
          hours: Math.floor(diffInMinutes / minutesInHour),
          timestamp: timestamp
        });
      }
      if (diffInMinutes < minutesInMonth) {
        return formatMessage(_messages["default"].campaign_days_ago, {
          days: Math.floor(diffInMinutes / minutesInDay),
          timestamp: timestamp
        });
      }
      if (diffInMinutes < minutesInYear) {
        return formatMessage(_messages["default"].campaign_months_ago, {
          months: Math.floor(diffInMinutes / minutesInMonth),
          timestamp: timestamp
        });
      }
      return formatMessage(_messages["default"].campaign_years_ago, {
        years: Math.floor(diffInMinutes / minutesInYear),
        timestamp: timestamp
      });
    });
    return _this;
  }
  _inherits(CampaignQuestionComponent, _Component);
  return _createClass(CampaignQuestionComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
        form = _this$props7.form,
        user = _this$props7.store.auth.user;
      if (form && user) {
        form.$('user').sync(user.fullName);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var form = this.props.form;
      if (form) {
        form.reset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var step = this.props.step;
      if (step === 'question') {
        return this.renderQuestion();
      }
      if (step === 'follow-up-question') {
        return this.renderFollowUpQuestion();
      }
      if (step === 'summary' || step === 'thank-you') {
        return this.renderSummary();
      }
      return null;
    }
  }]);
}(_react.Component), _defineProperty(_CampaignQuestionComponent, "propTypes", {
  device: _propTypes["default"].oneOf(['desktop', 'mobile']).isRequired,
  disableModal: _propTypes["default"].bool,
  followUpQuestion: _propTypes["default"].object,
  form: _propTypes["default"].object,
  isSubmissionFailureModalOpen: _propTypes["default"].bool,
  lastDateOfAnswerForUser: _propTypes["default"].instanceOf(Date),
  onAnswer: _propTypes["default"].func,
  onFollowUpAnswer: _propTypes["default"].func,
  onSubmissionFailureModalClose: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  question: _propTypes["default"].object,
  SliderComponent: _propTypes["default"].elementType.isRequired,
  step: _propTypes["default"].oneOf(['none', 'question', 'follow-up-question', 'summary', 'thank-you'])
}), _CampaignQuestionComponent)) || _class) || _class) || _class) || _class);
var _default = exports["default"] = CampaignQuestionComponent;
//# sourceMappingURL=index.js.map